import { isNullOrUndefined } from "../form-client";

export { isNullOrUndefined };

export function buildUrl(base: string, params: any) {
	const query = Object.keys(params)
		.filter((key) => params[key] !== undefined && params[key] !== null)
		.map((key) => `${key}=${encodeURIComponent(String(params[key]))}`)
		.join("&");

	if (!query) return base;
	return `${base}${base.includes("?") ? "&" : "?"}${query}`;
}

function getClientPortalLandingBase(): string {
	const baseHref = document.getElementsByTagName("base")[0]?.getAttribute("href") || "/";
	const normalizedBase = baseHref.endsWith("/") ? baseHref.slice(0, -1) : baseHref;
	return `${window.location.origin}${normalizedBase}/landing`;
}

export async function openForm(
	formId: string,
	keyValue: string,
	formMode: string,
	eventDef: string,
	programPs: string,
	sitePs: string,
	parentValue: string,
	completeSchedEvent: boolean = false,
	peId: string = "",
	stId: string = "",
	unitId: string = ""
) {
	const resolvedKeyValue = keyValue || "NEW";
	const url = buildUrl(getClientPortalLandingBase(), {
		event_id: eventDef,
		parent_value: parentValue,
		form_header_id: formId,
		key_value: resolvedKeyValue,
		form_mode: formMode || "ADD",
		sitePS: sitePs || "",
		programPS: programPs || "",
		serviceTrack: stId || "",
		programEnrollment: peId || "",
		unitsId: unitId || "",
		events2do_id: completeSchedEvent ? resolvedKeyValue : "",
		completeSchedEvent: completeSchedEvent,
		is_complete_sched_event: completeSchedEvent,
	});

	return window.open(url, "_blank");
}
